import React, { Component } from 'react';
import PropTypes from 'prop-types';
import $ from '@alife/alpha-jquery/jquery';
import safeLog from '@alife/bc-safe-log';
import safeGet from 'src/utils/safe-get';
import classnames from 'classnames';
import eventManager from '@alife/scc-event-manager/event-manager';
import Icon from '@alifd/next/lib/icon/index';
import Balloon from '@alifd/next/lib/balloon/index';
import gdata from '@alife/bc-gdata';
import throttle from 'lodash.throttle';
import AnimateNumber from '@alife/bc-animate-number';
import CallUsBtn from './call-us';
import ContactSupplierBtn from './contact-supplier';
import Logistics from './logistics';
import Total from './total';
import Warning from './warning';
import FixHeader from './fix-header';
import ArriveOn from './arrive-on';
import { log } from './utils';

export default class FloatMarketAction extends Component {
  static propTypes = {
    i18n: PropTypes.object,
    productId: PropTypes.number,
    productEncryptId: PropTypes.string,
    productIsMarketGoods: PropTypes.bool,
    productIsHang: PropTypes.bool, // 商品是否挂起
    umidToken: PropTypes.string,
    productOwnMemberAlitalkEncryptId: PropTypes.string,
    contactEncryptId: PropTypes.string,
    contactName: PropTypes.string,
    photoUrl: PropTypes.string,
    mediaItems: PropTypes.array,
    subject: PropTypes.string,
    ladderPeriodList: PropTypes.array,
    shippingDate: PropTypes.string,
    moq: PropTypes.number,
    hasVideoChat: PropTypes.bool,
    csTestVersion: PropTypes.string,
  };

  constructor(props) {
    super(props);

    let productPicture = '';
    const { mediaItems = [], subject = '' } = props;
    const firstImageItem = mediaItems[0];
    if (firstImageItem.type === 'image') {
      productPicture = safeGet(firstImageItem, 'imageUrl.thumb');
    } else if (firstImageItem.type === 'video') {
      productPicture = safeGet(firstImageItem, 'videoCoverUrl');
    }

    const { moq } = props;

    this.state = {
      subtotalQuantity: 0,
      subtotalCost: 0,
      logisticsCountry: 'US',
      logisticsMethod: 'FedEx',
      logisticsCost: 100,
      logisticsTime: '',
      tradeTerm: '',
      leadTime: this.getLeadTime(moq, false, ''),
      totalCost: 0,
      isSoldout: false,
      showStartOrder: true,
      showCS: true,
      showCart: true,
      showChat: true,
      moqUnit: '',
      showFloatAction: false,
      logisticsIsEmpty: true,
      originalCost: 0,
      isFreeShipping: false,
      discount: null,
      orderWarning: '',
      cartWarning: '',
      fixed: false,
      productName: subject,
      productPicture,
      showCartTip: false,
      isSku: false,
      isVb: false,
      logisticsCostCalculationType: undefined,
      canHoverTipWarning: true,
      moq: 0,
      lastAttrName: '',
      showPromotion: false,
      activityFlagUrl: null,
      warehouseType: '',
      isOverseaProduct: false,
      deliveredDate: 0,
      shippingActivityId: null,
    };
  }

  componentDidMount() {
    eventManager.on('init', this.handleInit);
    eventManager.on('calchange', this.handleCalChange);
    eventManager.on('expressConfirm', this.handleLogisticsChange);
    eventManager.on('logisticsChange', this.handleLogisticsChange);
    eventManager.on('logisticsChange:empty', this.handleLogisticsChange);
    // eventManager.on('leadtimeChange', this.handleLeadtimeChange);
    eventManager.on('cartWarning', this.handleCartWarning);
    eventManager.on('moqWarning', this.handleMoqWarning);
    eventManager.on(
      'floatSideActionChange',
      throttle(this.handleFloatChange, 500),
    );
    eventManager.on('addCartSucess', this.handleAddCartSuccess);
    eventManager.on(
      'displayRightActionMoqWarning',
      this.handleDisplayRightActionMoqWarning,
    );
  }

  getPosition = () => {
    return this.state.fixed ? 'float' : 'top';
  };

  getLeadTime(
    quantity,
    isOverseaProduct = this.state.isOverseaProduct,
    warehouseType = this.state.warehouseType,
  ) {
    if (
      isOverseaProduct &&
      (warehouseType === 'ALI_WH' || warehouseType === 'OVERSEA_INVENTORY')
    ) {
      return 1;
    }

    let leadTimeValue = -1;
    const { ladderPeriodList = [], shippingDate = '-' } = this.props;
    const priceRangeItem = ladderPeriodList.find(ladderPeriod => {
      return (
        quantity >= ladderPeriod.minQuantity &&
        quantity <= ladderPeriod.maxQuantity
      );
    });
    if (priceRangeItem) {
      leadTimeValue = priceRangeItem.processPeriod;
    }

    return leadTimeValue === -1 ? shippingDate : leadTimeValue;
  }

  handleAddCartSuccess = () => {
    this.setState({ showCartTip: true }, () => {
      setTimeout(() => this.setState({ showCartTip: false }), 3500);
    });
  };

  handleCartWarning = data => {
    log(data);
    this.setState({ cartWarning: data.msg }, () => {
      setTimeout(() => this.setState({ cartWarning: '' }), 5000);
    });
  };

  handleMoqWarning = data => {
    log(data);
    this.setState({ orderWarning: data.msg });
  };

  handleInit = data => {
    log(data, 'init');
    const {
      quantity,
      isSku,
      moqUnit,
      // fee,
      prices,
      totalPrices,
      // currencyTip,
      // logisticsData,
      // logisticsPrice,
      logisticsTime,
      tradeTerm,
      logisticsCost,
      logisticsMethod,
      // country,
      // fromWarehouseCode,
      originalCost,
      activityTips,
      // isOverseaProduct,
      // leadTime,
      // leadTimeNotMatch,
      // leadTimeText,
      isTxt,
      isSoldout,
      discount,
      multiDispatchPlace,
      isVb,
      moq,
      lastAttrName,
      showPromotion,
      activityFlagUrl,
      isOverseaProduct,
      warehouseType,
      shippingActivityId,
      deliveredDate,
    } = data;
    this.setState({
      ...this.state,
      subtotalQuantity: quantity,
      subtotalCost: prices,
      totalCost: totalPrices,
      // logisticsCountry: fullCountry,
      logisticsMethod,
      logisticsCost,
      logisticsTime,
      tradeTerm,
      // leadTime,
      moqUnit,
      discount,
      logisticsIsEmpty: isTxt,
      originalCost,
      isFreeShipping: logisticsCost == 0,
      showCart: gdata.get('hideSoBtn') ? false : !multiDispatchPlace,
      isSoldout,
      isSku,
      isVb,
      moq,
      lastAttrName,
      showPromotion,
      activityFlagUrl,
      activityTips,
      isOverseaProduct,
      leadTime: this.getLeadTime(moq, isOverseaProduct, warehouseType),
      shippingActivityId,
      deliveredDate,
    });
  };

  handleDisplayRightActionMoqWarning = show => {
    this.setState({
      canHoverTipWarning: show,
    });
  };

  handleCalChange = data => {
    log(data);
    const {
      quantity,
      // isSku,
      moqUnit,
      // fee,
      prices,
      totalPrices,
      // currencyTip,
    } = data;
    this.setState({
      subtotalQuantity: quantity,
      subtotalCost: prices,
      totalCost: totalPrices,
      moqUnit,
      cartWarning: '',
      orderWarning: '',
      leadTime: this.getLeadTime(quantity),
    });
  };

  handleLogisticsChange = data => {
    log(data);

    const {
      // logisticsData,
      // logisticsPrice,
      logisticsTime,
      tradeTerm,
      logisticsCost,
      logisticsMethod,
      fullCountry,
      // country,
      // fromWarehouseCode,
      originalCost,
      activityTips,
      // isOverseaProduct,
      totalPrices,
      discount,
      isTxt,
      logisticsCostCalculationType,
      showPromotion,
      activityFlagUrl,
      deliveredDate, // 到货时间
      shippingActivityId,
    } = data;
    this.setState({
      ...this.state,
      logisticsCountry: fullCountry,
      logisticsMethod,
      logisticsCost,
      logisticsTime,
      tradeTerm,
      totalCost: totalPrices,
      discount,
      logisticsIsEmpty: isTxt,
      originalCost,
      isFreeShipping: logisticsCost == 0,
      logisticsCostCalculationType,
      showPromotion,
      activityFlagUrl,
      activityTips,
      deliveredDate,
      shippingActivityId,
    });
  };

  handleLeadtimeChange = data => {
    log(data);
    this.setState({ leadTime: data.leadTime });
  };

  handleFloatChange = show => {
    if (show) {
      $('.module-floatMarketAction').css(
        'height',
        $('.module-floatMarketAction').height(),
      );
    } else {
      $('.module-floatMarketAction').css('height', 'auto');
    }
    this.setState({ fixed: show });
  };

  openList = () => {
    $('.view-details-btn').trigger('click');
  };

  openLogistics = () => {
    safeLog('/sc.details.logisticClick', 'CLK');
  };

  so = () => {
    safeLog(
      '/sc.details.soBtn',
      'CLK',
      `position=${this.getPosition()}`,
      'GET',
    );
    $('#J-btn-order').trigger('click');
  };

  cs = () => {
    safeLog(
      '/sc.details.csBtn',
      'CLK',
      `position=${this.getPosition()}`,
      'GET',
    );
    // $('.wholesale-cs-btn').trigger('click');
  };

  video = () => {
    safeLog('/sc.details.videoBtn', 'CLK', 'action=videocallclick', 'GET');
  };

  cart = () => {
    safeLog(
      '/sc.details.cartBtn',
      'CLK',
      `position=${this.getPosition()}`,
      'GET',
    );
    $('#J-btn-shopping-cart').trigger('click');
  };

  chat = () => {
    $('.ma-sub-operate [data-role="alitalk"]').trigger('click');
  };

  render() {
    const {
      subtotalQuantity,
      subtotalCost,
      logisticsCountry,
      logisticsMethod,
      logisticsCost,
      logisticsTime,
      leadTime,
      tradeTerm,
      totalCost,
      isSoldout,
      showStartOrder,
      showCS,
      showCart,
      // showChat,
      moqUnit,
      // showFloatAction,
      discount,
      logisticsIsEmpty,
      originalCost,
      isFreeShipping,
      orderWarning,
      cartWarning,
      fixed,
      productName,
      productPicture,
      showCartTip,
      isSku,
      logisticsCostCalculationType,
      isVb,
      canHoverTipWarning,
      moq,
      lastAttrName,
      showPromotion,
      activityFlagUrl,
      activityTips,
      deliveredDate,
      shippingActivityId,
    } = this.state;
    const {
      contactEncryptId,
      contactName,
      photoUrl,
      productOwnMemberAlitalkEncryptId,
      i18n = {},
      productId,
      hasVideoChat,
      csTestVersion,
      productIsHang,
    } = this.props;

    const isAlitalkNew = csTestVersion === 'VA';

    return (
      <div className="module-floatMarketAction-vb module-detail-actions">
        <div
          className={
            fixed
              ? 'float-action-inner float-action-inner-fixed'
              : 'float-action-inner'
          }
        >
          {fixed && (
            <FixHeader
              productName={productName}
              productPicture={productPicture}
            />
          )}
          <ul className="sub-area">
            {!isVb ? (
              <li className="sub-item">
                <span className="sub-item-name">
                  {i18n['rightAction.subtotal']} (
                  <span
                    className={classnames({
                      'hover-line': subtotalQuantity > 0 && isSku,
                    })}
                    onClick={
                      subtotalQuantity > 0 && isSku ? this.openList : undefined
                    }
                  >
                    {subtotalQuantity} {moqUnit}
                  </span>
                  )
                </span>
                <span className="sub-item-right">
                  <AnimateNumber value={subtotalCost} />
                </span>
              </li>
            ) : null}
            {isVb && subtotalQuantity ? (
              <li className="sub-item">
                <span className="sub-item-name">
                  <span
                    className={classnames({
                      'hover-line': subtotalQuantity > 0 && isSku,
                    })}
                    onClick={
                      subtotalQuantity > 0 && isSku ? this.openList : undefined
                    }
                  >
                    {subtotalQuantity} {moqUnit}
                  </span>
                </span>
                <span className="sub-item-right">
                  <AnimateNumber value={subtotalCost} />
                </span>
              </li>
            ) : null}
            <Logistics
              isEmpty={logisticsIsEmpty}
              method={logisticsMethod}
              discount={discount}
              handleClick={this.openLogistics}
              fullCountry={logisticsCountry}
              originalCost={originalCost}
              cost={logisticsCost}
              isFreeShipping={isFreeShipping}
              logisticsCostCalculationType={logisticsCostCalculationType}
              tradeTerm={tradeTerm}
              showPromotion={showPromotion}
              discountLimit={activityTips}
              activityFlagUrl={activityFlagUrl}
              shippingActivityId={shippingActivityId}
              i18n={this.props.i18n}
            />
            <li className="sub-item">
              <span className="sub-item-name float-lead-time">
                {i18n['rightAction.leadtime']} <b>{leadTime}</b>{' '}
                {i18n['rightAction.days']} &nbsp;
                <Balloon
                  trigger={<Icon type="prompt" size="small" />}
                  closable={false}
                  cache
                  align="bl"
                  popupContainer={() =>
                    document.querySelector('.float-action-inner')
                  }
                  style={{ maxWidth: '230px' }}
                >
                  <div>{i18n['rightAction.leadtimetip']}</div>
                </Balloon>
              </span>
            </li>
            {logisticsTime && (
              <li className="sub-item">
                <span className="sub-item-name float-shipping-time">
                  {i18n['rightAction.shippingTime']} <b>{logisticsTime}</b>{' '}
                  {i18n['rightAction.shippingTimeDays']} &nbsp;
                  <Balloon
                    trigger={<Icon type="prompt" size="small" />}
                    closable={false}
                    cache
                    align="bl"
                    popupContainer={() =>
                      document.querySelector('.float-action-inner')
                    }
                    style={{ maxWidth: '300px' }}
                  >
                    <div>{i18n['rightAction.shippingTimeTip']}</div>
                  </Balloon>
                </span>
              </li>
            )}

            {/* 物流抵达时间 */}
            {deliveredDate > 0 ? <ArriveOn value={deliveredDate} /> : null}
          </ul>
          <Total
            show={subtotalQuantity > 0}
            totalCost={totalCost}
            logisticsIsEmpty={logisticsIsEmpty}
            i18n={this.props.i18n}
          />
          {/* 售空 */}
          {isSoldout && !gdata.get('hideSoBtn') && (
            <button className="action-button-std action-button-std-disable">
              {i18n['rightAction.soldout']}
            </button>
          )}

          {/* 下单按钮 */}
          {!productIsHang &&
            showStartOrder &&
            !isSoldout &&
            (!isVb || (isVb && !canHoverTipWarning)) && (
              <button
                className="action-button-std action-start-order"
                id="J-action-start-order"
                onClick={this.so}
                data-domdot="id:3330"
                data-dot="d_type=place_order&cid=3330&product_desc=wholesale"
                data-spm-click="gostr=/sc;locaid=d1000"
              >
                {i18n['rightAction.so']}
              </button>
            )}

          {/* moq不足提示和下单置灰 */}
          {!productIsHang &&
            showStartOrder &&
            !isSoldout &&
            isVb &&
            canHoverTipWarning && (
              <Balloon
                trigger={
                  <button
                    className="action-button-std action-start-order"
                    id="J-action-start-order"
                    onClick={this.so}
                    data-domdot="id:3330"
                    data-dot="d_type=place_order&cid=3330&product_desc=wholesale"
                    data-spm-click="gostr=/sc;locaid=d1000"
                  >
                    {i18n['rightAction.so']}
                  </button>
                }
                closable={false}
                cache
                triggerType="hover"
                align="t"
                popupContainer={() =>
                  document.querySelector('.float-action-inner')
                }
                className="moq-strong-warning"
                needAdjust
                shouldUpdatePosition
              >
                <div>
                  <i className="next-icon next-icon-prompt next-icon-small" />
                  {i18n['undue_tpl_helpers.strongWarningText1']} {lastAttrName}{' '}
                  ({i18n['undue_tpl_helpers.strongWarningText2']}{' '}
                  <b>
                    {moq} {moqUnit}
                  </b>
                  ) {i18n['rightAction.toStartOrder']}
                </div>
              </Balloon>
            )}
          {!isVb && <Warning msg={orderWarning} />}

          {/* 询盘按钮 */}
          {showCS && showStartOrder && (
            <ContactSupplierBtn
              i18n={i18n}
              onClick={this.cs}
              domdot="id:3301,ext:'other=mainaction'"
              className="action-button-std action-cs"
              href={`//message.alibaba.com/msgsend/contact.htm?action=contact_action&domain=1&id=${this.props.productId}&id_f=${this.props.productEncryptId}&mloca=main_en_detail&tracelog=tracedetailfeedback&umidToken=${this.props.umidToken}`}
              contactName={contactName}
              productId={productId}
              productOwnMemberAlitalkEncryptId={
                productOwnMemberAlitalkEncryptId
              }
              contactEncryptId={contactEncryptId}
              photoUrl={photoUrl}
              isNewVersion={isAlitalkNew}
              productIsHang={productIsHang}
            />
          )}

          {/* 不展示下单按钮时，询盘按钮变为主按钮 */}
          {showCS && !showStartOrder && (
            <ContactSupplierBtn
              i18n={i18n}
              onClick={this.cs}
              domdot="id:3301,ext:'other=mainaction'"
              className="action-button-std action-cs-as-so"
              href={`//message.alibaba.com/msgsend/contact.htm?action=contact_action&domain=1&id=${this.props.productId}&id_f=${this.props.productEncryptId}&mloca=main_en_detail&tracelog=tracedetailfeedback&umidToken=${this.props.umidToken}`}
              contactName={contactName}
              productId={productId}
              productOwnMemberAlitalkEncryptId={
                productOwnMemberAlitalkEncryptId
              }
              contactEncryptId={contactEncryptId}
              photoUrl={photoUrl}
              isNewVersion={isAlitalkNew}
              productIsHang={productIsHang}
            />
          )}

          {/* 音视频通话按钮 */}
          {hasVideoChat ? (
            <CallUsBtn
              ownMemberAlitalkEncryptId={productOwnMemberAlitalkEncryptId}
              i18n={i18n}
              productId={productId}
              contactEncryptId={contactEncryptId}
              contactName={contactName}
              photoUrl={photoUrl}
            />
          ) : null}

          {/* 购物车按钮 */}
          {!productIsHang && showCart && !isSoldout && (
            <button
              className="action-button-lite"
              onClick={this.cart}
              data-spm="1001"
            >
              <i className="ui2-icon ui2-icon-cart" />
              {!showCartTip && (
                <span className="float-add-cart">
                  {i18n['rightAction.addCart']}
                </span>
              )}
              {showCartTip && (
                <span className="float-add-cart-success">
                  {i18n['rightAction.addCartSuccess']}
                </span>
              )}
            </button>
          )}

          {/* 购物车加购成功文案区 */}
          {cartWarning && <Warning msg={cartWarning} />}

          {/* 悬浮状态下ta信保提示 */}
          {fixed && (
            <div className="ta-tip-container">
              <div className="ta-tip-title">{i18n['rightAction.ta.tip1']}</div>
              <img
                className="ta-tip-img"
                src="//img.alicdn.com/tfs/TB1xiBajoT1gK0jSZFhXXaAtVXa-26-28.svg"
                alt="ta"
              />
              <div>
                <div className="ta-tip-ta">{i18n['rightAction.ta.title']}</div>
                <div className="ta-tip-info">{i18n['rightAction.ta.tip2']}</div>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}
